import {SocialFooter} from "../components/common/CommonLayout";
import React from "react";
import {useAppDispatch} from "../components/common/Global";
import {setPageTitle} from "./common/NavigationState";
import {ContentBox} from "../components/ContentBox";
import {TextPanel} from "../components/TextPanel";
import {Media_MobileAny, Media_Tablet_Plus} from "../components/common/Extensions";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import YouTubeIcon from "@mui/icons-material/YouTube";
import EditNoteIcon from "@mui/icons-material/EditNote";
import VideocamIcon from "@mui/icons-material/Videocam";
import AudioFileIcon from "@mui/icons-material/AudioFile";
import CropIcon from "@mui/icons-material/Crop";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import {Box, Link} from "@mui/material";

export const AboutPage = () => {
  const dispatch = useAppDispatch();
  dispatch(setPageTitle("About Us"));

  return (
    <>
      <WhatIsPanel />
      <CreatorsPanel />
      <ContactUsPanel />
      <BehindTheScenesPanel />
      <SocialFooter />
    </>
  );
};

const WhatIsPanel = () => (
  <ContentBox image="music">
    <TextPanel
      flavor="What we do"
      title="What is OCWALK"
      description={
        <>
          OCWALK is aimed to help new ocarina players get into the hobby. <br />
          We arrange music into ocarina tabs and record the demonstration videos. <br />
          All of our work is available for free, and that will never change!
        </>
      }
      align="right"
    />
  </ContentBox>
);

const CreatorsPanel = () => (
  <ContentBox image="generic">
    <TextPanel
      flavor="Who we are"
      title="Creators"
      description={
        <>
          I am <Link href="https://bsky.app/profile/radiantwisp.bsky.social">RadiantWisp</Link>, author of OCWALK. <br />
          You see my face on most of the videos! <br />
          I work alongside another person, who bring tremendous help with the process. <br /><br />
          And that's it! OCWALK is a big effort of a teeny tiny team :)
        </>
      }
      align="left"
    />
  </ContentBox>
);

const ContactUsPanel = () => (
  <ContentBox unlockHeight image="vynil">
    <TextPanel
      flavor="Have a question?"
      title="Contact Us"
      description={
        <>
          Tell us anything via email: <Link href="mailto:owispyo@gmail.com">owispyo@gmail.com</Link><br />
          Subscribe to us on YouTube: <Link href="https://www.youtube.com/@OcarinaWalk">youtube.com/@OcarinaWalk</Link><br />
          Ask a question on OCWALK Discord: <Link href="https://discord.com/invite/QX7C3YsSnF">discord.com/ocwalk</Link><br />
          Support the project on Patreon: <Link href="https://www.patreon.com/c/wispy">patreon.com/wispy</Link><br /><br />
          Catch me streaming live on Twitch: <Link href="https://www.twitch.tv/radiantwisp">twitch.tv/radiantwisp</Link><br />
          Follow my humble page on Bluesky: <Link href="https://bsky.app/profile/radiantwisp.bsky.social">bsky.app/radiantwisp</Link><br />
        </>
      }
      align="right"
      primaryButtonTitle="Send Email"
      primaryButtonUrl="mailto:owispyo@gmail.com"
      secondaryButtonTitle="Join Discord"
      secondaryButtonUrl="https://discord.com/invite/QX7C3YsSnF"
    />
  </ContentBox>
);

const BehindTheScenesPanel = () => (
  <ContentBox unlockHeight image="ocarinas">
    <TextPanel
      flavor="How we do it"
      title="Behind the Scenes"
      description={
        <>
          There is quite a bit of work involved to make ocarina content. <br />
          Here is the process we go through for every video and tabs: <br />
          <TextIcon icon={<MusicNoteIcon />} /> Choose songs to be arranged
          <br />
          <TextIcon icon={<FindInPageIcon />} /> Look for source materials for the song
          <br />
          <TextIcon icon={<EditNoteIcon />} /> Arrange song into tabs for a 12-hole ocarina
          <br />
          <TextIcon icon={<VideocamIcon />} /> Record a demonstration video
          <br />
          <TextIcon icon={<AudioFileIcon />} /> Extract and edit the audio (noise removal, audio levels, eq)
          <br />
          <TextIcon icon={<CropIcon />} /> Edit and render the video
          <br />
          <TextIcon icon={<YouTubeIcon />} /> Upload the video to YouTube and tabs to website
          <br />
          <TextIcon icon={<AnnouncementIcon />} /> Announce the video after release
          <br />
          We use a custom built software that we call "Composer" to assist with the process.
        </>
      }
      align="left"
    />
  </ContentBox>
);

const TextIcon = (props: {icon: React.ReactNode}) => (
  <>
    <Media_MobileAny>-</Media_MobileAny>
    <Media_Tablet_Plus>
      <Box sx={{verticalAlign: "-5px", display: "inline-block", paddingRight: 1}}>{props.icon}</Box>
    </Media_Tablet_Plus>
  </>
);
